import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import clsx from 'clsx';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    boxShadow: theme.shadows[1],
    width: '100%',
    aspectRatio: '8.5 / 11',
    margin: '0 auto',
    overflow: 'scroll',
    maxWidth: theme.pxToRem(1000), // same size as current IUH template
  },
}));

export type TemplateResultOwnProps = {
  className?: string;
  templateResult: string;
};

export type TemplateResultProps = TemplateResultOwnProps;

const TemplateResult: React.FC<TemplateResultProps> = ({
  templateResult,
  className,
}) => {
  const classes = useStyles({});

  // the backend will scrub the template for XSS.  This is an extra layer of defense. The iframe is sandboxed, so it can't access the parent window
  return (
    <iframe
      title="Survey Result Template"
      srcDoc={templateResult}
      className={clsx(classes.root, className)}
      frameBorder="0"
      sandbox=""
    />
  );
};

export default React.memo(TemplateResult);
